<article class="field-wrapper">
    <section class="field">
        @if (label()) {
            <span class="label">{{ label() }}</span>
        }
        <input
            type="text"
            [formControl]="control()"
            [readonly]="readonly()"
            [placeholder]="placeholder()"
            [class.error]="control().invalid && control().touched"
            class="field-input"
            [appTrimSpaces]="shouldTrimSpaces()"
        />
    </section>
    <section class="errorField">
        @if (control().invalid && control().touched) {
            <span class="errorMessage">
                @if (control().hasError('required')) {
                    {{ label() || 'This field' }} is required
                }
                @if (control().hasError('maxlength')) {
                    Maximum {{ control().getError('maxlength').requiredLength }} characters
                }
            </span>
        }
    </section>
</article>
